/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Deck_Attribution_ForbiddenInputs */



/**
* | output |
* | --- |
* | "Only the player can change their own deck's attribution" |
*
* @param {Err_Tournament_Deck_Attribution_ForbiddenInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_deck_attribution_forbidden = /** @type {((inputs?: Err_Tournament_Deck_Attribution_ForbiddenInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Deck_Attribution_ForbiddenInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Seul le joueur peut changer l'attribution de son propre deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Solo el jugador puede cambiar la atribución de su propio deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Apenas o jogador pode alterar a atribuição do seu próprio deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solo il giocatore può cambiare l'attribuzione del proprio deck")
	return /** @type {LocalizedString} */ ("Only the player can change their own deck's attribution")
});